module.exports = __webpack_public_path__ + "img/timeline_miscevent-13.37d08035.jpg";